<template>
  <Transition name="fade">
    <aside v-if="opened" :class="['modal', {'--form': $route.query[QUERY_KEYS['FORM']]}]" @click="close">
      <div class="modal__content">
        <button class="button --arrow modal__button">
          <Icon id="x"/>
        </button>
        <YoutubeModal v-if="$store.state.app.youtube_id" :id="$store.state.app.youtube_id" @click.stop/>
        <VideoModal v-if="$store.state.app.video_link" :content="$store.state.app.video_link" @click.stop />
        <ContentCardModal v-if="!$store.state.app.youtube_id && !$store.state.app.video_link && $store.state.app.card" @click.stop/>
        <EmployeeModal v-if="!$store.state.app.youtube_id && !$store.state.app.video_link && !$store.state.app.card && $store.state.app.employee" @click.stop/>
        <FormModal v-if="$route.query[QUERY_KEYS['FORM']]" @click.stop/>
      </div>
    </aside>
  </Transition>
</template>

<script>
import {ContentCardModal, EmployeeModal, FormModal, YoutubeModal, VideoModal} from '@/components/modal/blocks'
import {Icon} from '@/components/global'
import {bodyHelpers} from '@/helpers'
import {UsesRoutesMixin} from '@/mixins'

export default {
  name: 'Modal',
  mixins: [UsesRoutesMixin],
  components: {ContentCardModal, EmployeeModal, FormModal, Icon, VideoModal, YoutubeModal},
  computed: {
    opened() {
      return this.$store.state.app.youtube_id || this.$store.state.app.employee || this.$store.state.app.card || this.$store.state.app.video_link || this.$route.query[this.QUERY_KEYS['FORM']]
    }
  },
  methods: {
    close() {
      if(this.$store.state.app.youtube_id) {
        this.$store.dispatch('updateYoutubeId')
      } else if(this.$store.state.app.card) {
        this.$store.dispatch('updateContentCard')
      } else if(this.$store.state.app.employee) {
        this.$store.dispatch('updateEmployee')
      } else if(this.$store.state.app.video_link) {
        this.$store.dispatch('updateVideoContent')
      } else if(this.$route.query[this.QUERY_KEYS.FORM]) {
       this.$router.push({...this.$route, query: null})
      }
    }
  },
  watch: {
    'opened'() {
      this.opened ? bodyHelpers.lock() : bodyHelpers.unlock()
    }
  }
}
</script>